import { Component } from '@angular/core';

import { OpportunityBaseComponent } from '@accuservpro/xplat/features';

@Component({
    selector: 'accuservpro-opportunity',
    templateUrl: 'opportunity.component.html',
    standalone: false
})
export class OpportunityComponent extends OpportunityBaseComponent {

  constructor() {
    super();
  }
}